import React, {useState, useEffect} from 'react';

import { Link } from "react-router-dom";

import InternetPackage from './InternetPackage';

import GoogleMapReact from 'google-map-react';

import * as vars from './../vars.js';
import * as funcs from './../funcs.js';

import Geocode from "react-geocode";

import { ReactSession } from 'react-client-session';

import uuid from 'react-uuid';
import { sha256, sha224 } from 'js-sha256';

import Loading from './Loading';


const { encode } = require('pluscodes');

// set Google Maps Geocoding API for purposes of quota management. Its optional but recommended.
Geocode.setApiKey("AIzaSyDTfdfpJr-bqCFo2yhK3En9PvuyOt2mdFI");

// set response language. Defaults to english.
Geocode.setLanguage("en");


Geocode.setLocationType("ROOFTOP");




function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// Read ?lat=…&lng=… from the URL and return {lat,lng} when both are
// finite numbers inside the world bounds, else null. The /plans page
// uses this on first paint to restore a deep-linked / refreshed pin
// position. Old browsers without URLSearchParams just silently fall
// through to defaults — they get the default center, no error.
function readLatLngFromUrl() {
  try {
    var params = new URLSearchParams(window.location.search);
    var lat = parseFloat(params.get('lat'));
    var lng = parseFloat(params.get('lng'));
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
    return { lat: lat, lng: lng };
  } catch (_) { return null; }
}

// Replace the URL's query string with the current pin position, keeping
// the path + hash intact. replaceState (not pushState) — every drag
// shouldn't flood the back-button history, but a refresh should still
// land back on the same pin.
function writeLatLngToUrl(lat, lng) {
  try {
    var u = new URL(window.location.href);
    u.searchParams.set('lat', Number(lat).toFixed(5));
    u.searchParams.set('lng', Number(lng).toFixed(5));
    window.history.replaceState(null, '', u.pathname + '?' + u.searchParams.toString() + u.hash);
  } catch (_) { /* old browser — no-op */ }
}

var ourMap;
var ourMaps;
var loadMapOnce=false;
//var checkInterval;
var haveInfo=false;

//lat: 51.070031542445406, lng: -104.95430850982665
var defaultProps = {
  center: {
    lat: 51.15452191765686, lng: -105.0064935684204
  },
  zoom: 11
};

var doOnce;

var whenObj = {};

function Availability(props) {

  ReactSession.setStoreType("localStorage");

  const [validPreorder, setValidPreorder] = useState(false);

  const [loading, setLoading] = useState(true);
  
  const [serviceLocation, setServiceLocation] = useState(false);
  const [serviceAddress, setServiceAddress] = useState(false);

  const [followingPackagesString, setFollowingPackagesString] = useState("Please drag the marker to a service location above in order to see the available packages.");

  const [locationString, setLocationString] = useState("");
  const [coordsString, setCoordsString] = useState("Drag the marker to your desired service location");
 
  const [dragMessage, setDragMessage] = useState(true);

  const [availability, setAvailability] = useState(-1);

  // Coverage data is loaded from the CMS at /api/coverage (same-origin —
  // hits the Fastify app behind the same Nginx vhost). Returns visible
  // zones + plans + products + defaultMarker. Hidden zones aren't in
  // here; they only surface via /api/coverage/lookup which checks
  // server-side and includes them.
  const [coverage, setCoverage] = useState(null);

  useEffect(() => {
    var aborted = false;
    fetch('/api/coverage', { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (!aborted && j) setCoverage(j); })
      .catch(function () { /* leave coverage null; UI shows loading */ });
    return function () { aborted = true; };
  }, []);

  // Adapt new /api/coverage plans to the legacy package shape that
  // InternetPackage already consumes (price in dollars, availableRegion /
  // maxRegion integers). Derived from zoneSlugs intersected with zone
  // priorities so a plan offered in zones {hs_available, in_town} has
  // availableRegion=3 maxRegion=4.
  var adaptedPackages = [];
  var zoneBySlug = {};
  if (coverage && Array.isArray(coverage.zones)) {
    for (var zi = 0; zi < coverage.zones.length; zi++) zoneBySlug[coverage.zones[zi].slug] = coverage.zones[zi];
  }
  if (coverage && Array.isArray(coverage.plans)) {
    adaptedPackages = coverage.plans.map(function (pl) {
      var priorities = (pl.zoneSlugs || []).map(function (s) {
        return zoneBySlug[s] ? zoneBySlug[s].priority : 0;
      }).filter(function (n) { return n > 0; });
      return {
        value: pl.slug,
        type: pl.type,
        name: pl.name,
        requiresInstall: !!pl.requiresInstall,
        orderButtonText: pl.orderButtonText || 'Order',
        description: pl.description || '',
        marketing_description: pl.marketingDescription || '',
        oneTimePrice: (pl.oneTimePriceCents || 0) / 100,
        price:        (pl.monthlyPriceCents || 0) / 100,
        promo_price: ((pl.promoPriceCents != null ? pl.promoPriceCents : pl.monthlyPriceCents) || 0) / 100,
        download: pl.downloadMbps || 0,
        upload:   pl.uploadMbps   || 0,
        availableRegion: priorities.length ? Math.min.apply(null, priorities) : 0,
        maxRegion:       priorities.length ? Math.max.apply(null, priorities) : 0,
      };
    });
  }
  // Merge into a legacyInfo object so InternetPackage's existing logic
  // keeps working with no changes on its end.
  var legacyInfo = Object.assign({}, props.info || {}, { packages: adaptedPackages });

  // Server-side lookup — used on every marker drag. Returns ALL matching
  // zones (including hidden ones the marketing site can't see), sorted by
  // priority desc. We set `availability` to the highest matched priority,
  // matching the legacy 1/2/3/4 semantics that InternetPackage filters on.
  async function lookupAvailability(lat, lng, addr) {
    try {
      var r = await fetch('/api/coverage/lookup?lat=' + encodeURIComponent(lat) + '&lng=' + encodeURIComponent(lng), { credentials: 'omit' });
      var j = await r.json();
      var top = (j && Array.isArray(j.matchedZones) && j.matchedZones.length) ? j.matchedZones[0] : null;
      setAvailability(top ? top.priority : 0);
      setFollowingPackagesString(top
        ? 'The following packages are available at: ' + addr
        : 'No packages are available at: ' + addr);
    } catch (e) {
      setAvailability(0);
      setFollowingPackagesString('Could not check availability for: ' + addr);
    }
  }


  let historicalOverlay;

  // Track rendered polygon + marker instances so we can refresh them
  // when coverage arrives after the map is already up (race between
  // GoogleMapReact onGoogleApiLoaded and the /api/coverage fetch).
  var renderedPolygons = [];
  var renderedMarker = null;

  // Pulled out of loadMap so the marker dragend handler still has access
  // after the closure shape was refactored. Uses the authoritative
  // server-side /api/coverage/lookup (which includes hidden zones)
  // instead of doing client-side polygon math.
  function draggingEnded(thing) {
    setDragMessage(false);
    var pos = thing.getPosition().toJSON();
    setServiceLocation(pos);

    // Reflect the pin position in the URL so a refresh / share / bookmark
    // lands on the same spot. Doing this on dragend rather than waiting
    // for the geocoder means the URL updates immediately and survives
    // offline / geocoder hiccups.
    writeLatLngToUrl(pos.lat, pos.lng);

    Geocode.fromLatLng(pos.lat, pos.lng).then(
      function (response) {
        var address = response.results[0].formatted_address;
        setLocationString('I would like service at');
        setCoordsString(address);
        setServiceAddress(address);
        lookupAvailability(pos.lat, pos.lng, address);
      },
      function () {
        var coordStr = (Math.round(pos.lat * 10000) / 10000) + ', ' + (Math.round(pos.lng * 10000) / 10000);
        setLocationString('I would like service at');
        setCoordsString(coordStr);
        lookupAvailability(pos.lat, pos.lng, coordStr);
      }
    );
  }

  function renderCoverageOverlays(map, maps, cov) {
    if (!map || !maps || !cov) return;

    // Clear any previously rendered polygons (idempotent — safe to call
    // again when coverage refreshes).
    for (var i = 0; i < renderedPolygons.length; i++) {
      try { renderedPolygons[i].setMap(null); } catch (_) {}
    }
    renderedPolygons = [];

    // Single loop over CMS-managed zones. Hidden zones are filtered out
    // server-side and never reach this client — only visible ones get
    // drawn. Hidden-zone pricing still applies via the server lookup.
    var zones = Array.isArray(cov.zones) ? cov.zones : [];
    for (var z = 0; z < zones.length; z++) {
      var zone = zones[z];
      var polys = Array.isArray(zone.polygons) ? zone.polygons : [];
      for (var p = 0; p < polys.length; p++) {
        var poly = new maps.Polygon({
          paths: polys[p],
          strokeColor: zone.strokeColor || '#254d7e',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: zone.fillColor || '#3063a2',
          fillOpacity: 0.35,
        });
        poly.setMap(map);
        renderedPolygons.push(poly);
      }
    }

    // Marker — only create once; don't yank the user's marker out from
    // under them if coverage refreshes mid-session. Initial position
    // priority: URL ?lat=&lng= → coverage.defaultMarker → static fallback.
    if (!renderedMarker) {
      var urlPos = readLatLngFromUrl();
      var defLat = (cov.defaultMarker && cov.defaultMarker.lat) || defaultProps.center.lat;
      var defLng = (cov.defaultMarker && cov.defaultMarker.lng) || defaultProps.center.lng;
      var initLat = urlPos ? urlPos.lat : defLat;
      var initLng = urlPos ? urlPos.lng : defLng;
      renderedMarker = new maps.Marker({
        position: { lat: initLat, lng: initLng },
        map: map,
        draggable: true,
      });
      renderedMarker.addListener('dragend', function () {
        draggingEnded(this);
      });

      // Deep-link path: URL had a position. Pan the map to it (otherwise
      // a Strasbourg link viewed from the default zoom 11 could put the
      // pin near the edge) and replay a drop so the address +
      // availability + plans populate, just like the user dragged here.
      if (urlPos) {
        try { map.panTo({ lat: initLat, lng: initLng }); } catch (_) {}
        draggingEnded(renderedMarker);
      }
    }
  }

  var loadMap = (map, maps) => {
    ourMap = map;
    ourMaps = maps;
    if (!maps) return;
    loadMapOnce = true;
    // If coverage already arrived, render immediately; otherwise the
    // useEffect below fires renderCoverageOverlays when it does.
    if (coverage) renderCoverageOverlays(map, maps, coverage);
  };

  // Re-render polygons when coverage arrives after the map is loaded.
  useEffect(() => {
    if (ourMap && ourMaps && coverage) renderCoverageOverlays(ourMap, ourMaps, coverage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coverage]);

  async function detectPreorder() {
    const detectPreorder = await funcs.get('/orders/detectPreorder', {
      account_email: ReactSession.get("account_email"),
      account_token: ReactSession.get("account_token")
    }, (errors)=>{
      
    });

    if(detectPreorder.length>0) {
      setValidPreorder(true);
    } else {
      setValidPreorder(false);
    }

  }


  
  

  const [shiftImage1Style, setShiftImage1Style] = useState({backgroundPosition: 'right -10px'});

  window.addEventListener("scroll", (event) => {
    if(window !== undefined) {
      let scroll = window.scrollY;
      //console.log(scroll);
      setShiftImage1Style({backgroundPosition: 'right '+(-scroll*0.075-10)+'px'});
    }
  });

  useEffect(() => {

    whenObj.info = props.info;

    funcs.whenInfoLoaded(whenObj, async function() {
  

      haveInfo=true;
      detectPreorder();

      setLoading(false);

    });

    
  });


 


 
  async function clickedOrder(id) {

    var servLocString = serviceLocation.lat+', '+serviceLocation.lng;

    if(servLocString=='undefined, undefined') {
      servLocString = props.info.preorderCenter.lat+', '+props.info.preorderCenter.lng;
    }

    window.open('tel://13069004321', '_self');

    // const createServiceOrder = await funcs.post('/orders/orderServiceCreate', {
    //   account_email: ReactSession.get("account_email"),
    //   account_token: ReactSession.get("account_token"),
    //   package_id: id,
    //   service_location: servLocString
    // }, (errors)=>{

    //   //setCsoErrors(errors);
    //   window.open('#first_error', '_self');


    //   if(errors[0].code=='INVALID_TOKEN') {
    //     // If this is an account redirect error, set the account creation and login locations and messages...
    //     ReactSession.set("next_reason", 'To order service');
    //     ReactSession.set("next_url", errors[0].next_url);
    //   }

    //   for(var i=0;i<errors.length;i++) {
    //     if(errors[i].redirect_url) {
    //       window.open(errors[0].redirect_url, '_self');
    //     }
    //   }

      
    // });

    // // Handle these errors locally or proceed...
    // if(!createServiceOrder.errors) {
    //   window.open(createServiceOrder.redirect_url, '_self');
    // }
    


  }





  if(loading) { return (<><Loading /></>); }

  return (
    <div className="page">
      <div className="text_block_white">
        <h1>Availability Map</h1>
        <p>This tool details our network coverage area and available internet plans. Call us at <span className="blue_link"><b><a  href="tel://13069004321">1.306.900.4321</a></b></span> for more information, or to order service.</p>
      </div>

      <div style={{ height: '500px', width: '100%' }}>

          <GoogleMapReact
            bootstrapURLKeys={{ key: "AIzaSyDTfdfpJr-bqCFo2yhK3En9PvuyOt2mdFI" }}
            defaultCenter={defaultProps.center}
            defaultZoom={defaultProps.zoom}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map, maps }) => loadMap(map, maps)}
            

          >

            
          </GoogleMapReact>
          <div className="pleaseDrag">
            {locationString} <b>{coordsString}</b>
          </div>

          <div className={"serviceAvailable "+((availability==2 || availability==3)?"block":"hidden")}>
            <div className="sa_left"><img width="40" src="img/check400.png" /></div>
            <div className="sa_right">
            Service is available at this location!<br/>
            <a className="white_link" href="#view_packages"><b>View Packages</b></a></div>
          </div>
          <div className={"preorderAvailable "+(availability==1?"block":"hidden")}>
            <div className="sa_left"><img width="40" src="img/exclaim400.png" /></div>
            <div className="sa_right">
            Service not yet established here, but pre-order is available. <a className="white_link" href="#view_packages"><b>View Packages</b></a></div>
          </div>
          <div className={"notAvailable "+(availability==0?"block":"hidden")}>
            <div className="sa_left"><img width="40" src="img/x400.png" /></div>
            <div className="sa_right">
            Service not yet established here, pre-order not available. <a className="white_link" href="#learn_more"><b>Learn More</b></a></div>
          </div>

        </div>


      <div className="text_block_blue"  id="view_packages">

        <h1>Plans</h1>

        <p><i>{followingPackagesString}</i></p><br/>

        

        

        {/*<span className={validPreorder?'':'hidden'}><h2><i>You have a valid preorder!</i></h2></span>*/}

        

        {/*<InternetPackage info={props.info} packageId="0" availability={availability} clickedOrder={()=>{clickedOrder(0)}} />*/}

     

        {legacyInfo.packages.map((aPkg, index)=>{
          //console.log(aPkg+' + '+index);
           return <InternetPackage key={index} info={legacyInfo} packageId={index} availability={availability} clickedOrder={()=>{clickedOrder(index)}} />
       })}
        
       {/* <InternetPackage info={props.info} packageId="0" availability={availability} clickedOrder={()=>{clickedOrder(0)}} />

        {/*<h3>Call <span className="yellow_link"><a  href="tel://18254351010">1.825.435.1010</a></span> to Order Now</h3>*/}
      </div>

{/*      <div className="text_block_black" id="learn_more">
        <h3>Our Network is Still Growing</h3>
        <p>Our company is new and our network is growing. We have not yet established service widely across Saskatchewan but we're growing fast and this is our goal.</p>
        <p>If you continue to be interested in service, please check back in on this availability tool. This map is subject to frequent change and we will always keep it up-to-date.</p>
      </div>*/}

      {/* Bottom-of-page note: every plan supports a seasonal suspension —
          $20/mo to keep the account on standby for as many months as the
          customer needs (cabins, snowbirds). Reads as a footnote to the
          whole plan set rather than a per-plan caveat, which is why it
          lives outside InternetPackage. */}
      <div className="text_block_white" id="seasonal_suspension">
        <h2>Seasonal Suspension</h2>
        <p>Heading to the cabin only in summer, or south for the winter? Any of our plans can be <b>paused for $20/month</b> — your account stays active, your equipment stays in place, and you can resume full service whenever you're back. There's <b>no limit to how many months</b> you can stay suspended.</p>
        <p>While suspended you'll still have a usable connection at <b>5 Mbps down · 1 Mbps up</b> — enough to remotely check in on the property, run a security camera, or keep a smart thermostat online.</p>
        <p>Call us at <span className="blue_link"><b><a href="tel://13069004321">1.306.900.4321</a></b></span> to start or end a seasonal suspension.</p>
      </div>

    </div>);

}
  
export default Availability;

